module.exports = __webpack_public_path__ + "static/media/20210201.5ec96e5c.jpg";